import styled from 'styled-components/macro'

import { ReactComponent as GithubI } from './images/github.svg'
import { ReactComponent as XI } from './images/x-twitter-logo.svg'

// Hydra: We currently do not have a discord server
// export const DiscordIcon = styled(DiscordI)<{ size?: number; fill?: string }>`
//   height: ${({ size }) => (size ? size + 'px' : '32px')};
//   width: ${({ size }) => (size ? size + 'px' : '32px')};
//   fill: ${({ fill }) => fill ?? '#98A1C0'};
//   opacity: 1;
// `

export const GithubIcon = styled(GithubI)<{ size?: number; fill?: string }>`
  height: ${({ size }) => (size ? size + 'px' : '32px')};
  width: ${({ size }) => (size ? size + 'px' : '32px')};
  fill: ${({ fill }) => fill ?? '#98A1C0'};
  opacity: 1;
`

export const XIcon = styled(XI)<{ size?: number; fill?: string }>`
  height: ${({ size }) => (size ? size + 'px' : '32px')};
  width: ${({ size }) => (size ? size + 'px' : '32px')};
  fill: ${({ fill }) => fill ?? '#98A1C0'};
  opacity: 1;
`
